import { render, staticRenderFns } from "./shipment-private.vue?vue&type=template&id=5f404f47&scoped=true&"
import script from "./shipment-private.vue?vue&type=script&lang=js&"
export * from "./shipment-private.vue?vue&type=script&lang=js&"
import style0 from "./shipment-private.vue?vue&type=style&index=0&id=5f404f47&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f404f47",
  null
  
)

export default component.exports